export default "__VITE_ASSET__xrXUnKrI__"